export default __webpack_public_path__ + "static/media/fridge1-after2-480w.86c1e9fe.webp";